import React from 'react'
import { PlayButton, Timer, Progress } from 'react-soundplayer/components'
import { withCustomAudio } from 'react-soundplayer/addons'
import 'react-soundplayer/styles/buttons.css'
import 'react-soundplayer/styles/icons.css'
import 'react-soundplayer/styles/progress.css'
import 'react-soundplayer/styles/volume.css'
import './AudioPlayer.css'

const AudioPlayer = props => (
  <div className="AudioPlayer">
    <PlayButton {...props} />
    <Progress {...props} />
    <Timer {...props} />
  </div>
)

export default withCustomAudio(AudioPlayer)



// WEBPACK FOOTER //
// ./src/components/Audio/AudioPlayer.js